// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".make[data-v-7ba5bd90] {\n  position: fixed;\n  right: 40px;\n  bottom: 20px;\n  z-index: 999;\n}", ""]);
// Exports
module.exports = exports;
